module.exports = __webpack_public_path__ + "../static/media/5631-font.07cc1bb2.ttf";